import React from 'react';
interface ProgressBarProps {
  value: number;
  max?: number;
  variant?: 'success' | 'warning' | 'error' | 'brand';
  showLabel?: boolean;
}
export function ProgressBar({
  value,
  max = 100,
  variant = 'brand',
  showLabel = false
}: ProgressBarProps) {
  const percentage = Math.min(Math.max(value / max * 100, 0), 100);
  let colorClass = 'bg-[#0176d3]'; // brand
  if (value > 100) colorClass = 'bg-[#ba0517]'; // error
  else if (value === 100) colorClass = 'bg-[#2e844a]'; // success
  else if (value > 80) colorClass = 'bg-[#fe9339]'; // warning
  return <div className="w-full" data-id="element-199">
      {showLabel && <div className="flex justify-between text-xs mb-1" data-id="element-200">
          <span className="text-[#3e3e3c]" data-id="element-201">Ownership Total</span>
          <span className={`font-bold ${value > 100 ? 'text-[#ba0517]' : 'text-[#080707]'}`} data-id="element-202">
            {value}%
          </span>
        </div>}
      <div className="h-2 w-full bg-[#dddbda] rounded-full overflow-hidden" data-id="element-203">
        <div className={`h-full transition-all duration-500 ease-out ${colorClass}`} style={{
        width: `${percentage}%`
      }} data-id="element-204" />
      </div>
    </div>;
}